import * as $ from "jquery";
import imkt from '../../imkt';
import url from '../../utils/url';
import Modal from '../../components/generic/modal';

export default class VideoLink {
  sources = {
    youtube: function () {
      var srcUrl = "https://www.youtube.com/embed/" + this.params.videoId,
        videoParams = {
          autoplay: this.params.autoplay,
          modestbranding: this.params.modestbranding,
          enablejsapi: 1,
          rel: 0,
        },
        $embed = $("<iframe frameborder='0' allowfullscreen></iframe>");

      srcUrl = url.addUrlParams(videoParams, srcUrl);

      $embed.attr("src", srcUrl).addClass("youtube video video-tracking");
      return $embed;
    },
    vimeo: function () {
      var srcUrl = "//player.vimeo.com/video/" + this.params.videoId,
        videoParams = {
          autoplay: this.params.autoplay,
          title: 0,
          portrait: 0,
          byline: 0,
        },
        $embed = $("<iframe frameborder='0' allowfullscreen></iframe>");

      srcUrl = url.addUrlParams(videoParams, srcUrl);

      $embed.attr("src", srcUrl).addClass("vimeo video");

      return $embed;
    },
  };

  behaviors = {
    overlaySection: function () {
      if (!this.modal) {
        this.modal = new Modal({
          modalType: "video",
          fixed: false,
          centerVertically: false,
          modalContainer: this.domRoot.closest("section, .container-fluid"),
          id: this.params.videoId,
        });

        this.bindModalEvents();

        this.$videoPlayer = this.getVideoEmbed();
        this.modal.$modalContent.html(this.$videoPlayer);
        this.modal.$overlay
          .on("modal.place", $.proxy(this.placeSectionVideo, this))
          .on(
            "modal.show",
            $.proxy(function () {
              this.modal.params.modalContainer.addClass("modal-video");
            }, this)
          )
          .on(
            "modal.hide",
            $.proxy(function () {
              this.modal.params.modalContainer.removeClass("modal-video");
            }, this)
          );
      }
      this.modal.show();
      this.modal.place();
    },
    modal: function () {
      if (!this.modal) {
        this.modal = new Modal({
          modalType: "video",
        });

        this.bindModalEvents();

        this.$videoPlayer = this.getVideoEmbed();
        this.modal.$modalContent.html(this.$videoPlayer);
        this.modal.$overlay.on(
          "modal.place",
          $.proxy(this.placeModalVideo, this)
        );
      }
      this.modal.show();
      this.modal.place();
    },
  };
  domRoot: JQuery<HTMLElement>;
  params: any;
  $videoPlayer: any;
  modal: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = {
      // define default params here
      autoplay: 1,
      modestbranding: 1,
      rel: 0,
      aspectRatio: 16 / 9,
      addPlayButton: false,
      buttonSize: "medium",
      ...params,
    };
    this.init();
  }

  init() {
    if (!imkt.core.is.mobile()) {
      this.domRoot.on("click", $.proxy(this.onclick, this));
    }
  }

  onclick(e) {
    if (
      this.params.behavior &&
      this.behaviors.hasOwnProperty(this.params.behavior)
    ) {
      e.preventDefault();
      this.behaviors[this.params.behavior].call(this);
    }
  }

  getVideoEmbed() {
    if (this.params.source && this.sources.hasOwnProperty(this.params.source)) {
      return this.sources[this.params.source].call(this);
    }
  }

  getVideoDimensions($container) {
    var r = {
      height: null,
      width: null,
    };

    if (
      $container.outerWidth() / $container.outerHeight() >
      this.params.aspectRatio
    ) {
      r.top = 0;
      r.height = Math.round($container.outerHeight());
      r.width = Math.round(r.height * this.params.aspectRatio);
    } else {
      r.width = Math.round($container.outerWidth());
      r.height = Math.round(r.width / this.params.aspectRatio);
      r.top = Math.round(($container.outerHeight() - r.height) / 2);
    }

    return r;
  }

  pauseVideo() {
    if (this.params.source === "youtube") {
      this.issueYoutubeCommand("pauseVideo");
      // ID for Optimizely
      this.$videoPlayer.removeAttr("id");
    } else if (this.params.source === "vimeo") {
      this.issueVimeoCommand("pause");
    }
  }

  playVideo() {
    if (this.params.source === "youtube") {
      this.issueYoutubeCommand("playVideo");
      // ID for Optimizely
      this.$videoPlayer.attr("id", "youtube-video-active");
    } else if (this.params.source === "vimeo") {
      this.issueVimeoCommand("play");
    }
  }

  issueYoutubeCommand(command) {
    var iframe;
    if (this.$videoPlayer && this.$videoPlayer.length) {
      iframe = this.$videoPlayer[0].contentWindow;
      iframe.postMessage(
        '{"event":"command","func":"' + command + '","args":""}',
        "*"
      );
    }
  }

  issueVimeoCommand(command) {
    var iframe;
    if (this.$videoPlayer && this.$videoPlayer.length) {
      iframe = this.$videoPlayer[0].contentWindow;
      iframe.postMessage('{"method":"' + command + '","value":""}', "*");
    }
  }

  placeVideo(width, height, top, additionalClasses) {
    this.$videoPlayer
      .css({
        width: width,
        height: height,
      })
      .addClass(additionalClasses);

    this.modal.$modal.css({
      top: top,
    });
  }

  placeSectionVideo() {
    if (this.modal.$overlay) {
      var videoDimensions = this.getVideoDimensions(this.modal.$overlay);
      this.placeVideo(
        videoDimensions.width,
        videoDimensions.height,
        Math.max(0, videoDimensions.top)
      );
    }
  }

  placeModalVideo() {
    if (this.modal.$modal) {
      var videoWidth = this.modal.$modal.width();
      this.placeVideo(videoWidth, videoWidth / this.params.aspectRatio);
      this.modal.centerModal();
    }
  }

  bindModalEvents() {
    this.modal.$overlay
      .on("modal.shown", $.proxy(this.playVideo, this))
      .on("modal.hide", $.proxy(this.pauseVideo, this));
  }
}
